module.exports = __webpack_public_path__ + "assets/8902427dfec73780008418e72e95f232.png";